'use strict';
const
  axios = require('axios'),
  https = require('https'),

  { REACT_APP_ENV, TKN_KEY } = process.env,
  REACT_APP_TKN_SD = REACT_APP_ENV === 'production' ? 'dispatch-api-prod' : 'dispatch-api-test';

var _parent = {};

var tookan = {
  init: p => (_parent = p),

  /**
   * Retrieve driver's phone number from Tookan for Ride Hail
   *
   * @param  {Object} rideMove - Ride-Type Move data containing driver ID
   * @returns {String} - Driver's phone number
   */
  getDriverPhone: async (rideMove) => {
    let driverPhone;

    const agent = new https.Agent({
      rejectUnauthorized: false,
    });
    await axios({
      url: `https://${REACT_APP_TKN_SD}.socialautotransport.com/V2/view_fleet_profile`,
      method: 'post',
      data: {
        api_key: TKN_KEY,
        fleet_id: rideMove.driver_id,
      },
      headers: {
        'content-type': 'application/json',
      },
      //HOTFIX FOR CERT ERR
      httpsAgent: agent,
    }).then(async res => {
      if (res && res.data) {
        driverPhone = res.data.data.fleet_details[0].phone;
      } else {
        throw new Error("No response from Tookan driver profile", res);
      }
    });
    return driverPhone;
  }
};

module.exports = tookan;
